var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2967,
    cy: 40.2967,
    r: 37.7782,
    fill: "#D7D4F8",
    stroke: "#845BB3",
    strokeWidth: 5.03709
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9506 25.6052C35.5657 25.6052 36.8733 28.7785 35.0368 30.6297C33.1857 32.4661 30.0123 31.1586 30.0123 28.5435C30.0123 27.7642 30.3219 27.0168 30.8729 26.4658C31.424 25.9147 32.1713 25.6052 32.9506 25.6052ZM30.7469 32.9509H35.1544C35.9336 32.9509 36.681 33.2605 37.232 33.8115C37.7831 34.3626 38.0927 35.1099 38.0927 35.8892V43.9696H35.8889V54.9882H30.0123V43.9696H27.8086V35.8892C27.8086 35.1099 28.1182 34.3626 28.6692 33.8115C29.2202 33.2605 29.9676 32.9509 30.7469 32.9509ZM53.5188 34.4201H44.7038V37.3584H53.5188M53.5188 38.8275H49.1113V41.7658H53.5188M53.5188 25.6052H44.7038V28.5435H53.5188M53.5188 30.0126H49.1113V32.9509H53.5188M53.5188 43.235H44.7038V46.1733H53.5188M53.5188 52.0499H44.7038V54.9882H53.5188M53.5188 47.6424H49.1113V50.5807H53.5188",
    fill: "#845BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.498deed00dc6e0d2b3e825e64a95d295.svg";
export { ForwardRef as ReactComponent };